module.exports = __webpack_public_path__ + "media/18.de8bfd77.mp3";